// Suppliers types list
import {List, Map} from "immutable";

export const supplierTypes = new List([
    new Map({
        type_code: -1,
        type_name: 'Selecciona un tipo de proveedor'
    }),
    new Map({
        type_code: 'supplier',
        type_name: 'Proveedor'
    }),
    new Map({
        type_code: 'creditor',
        type_name: 'Acreedor'
    })
]);



// WEBPACK FOOTER //
// ./src/components/common/supplier-types.js